module.exports = __webpack_public_path__ + "static/christianwork2-64cdcb8bc88bb4053c76d8f65d685bc2.jpg";